<template>
  <slider-faq />

  <the-nav />

  <div class="main-wrap">
    <div id="faq">
      <div class="faq-fl">
        <div class="faq-title">Часто задаваемые вопросы и ответы</div>
        <div class="faq-cols f1">
          <div
            :class="`faq-item ${this.show === elem.id ? 'faq-item-show' : ''}`"
            v-for="elem in FAQ_LC"
            :key="elem.id"
            @click="this.show === elem.id ? (this.show = null) : (this.show = elem.id)"
          >
            <div class="faq-item-title">{{ elem.title }}</div>
            <div class="faq-item-text" v-if="this.show === elem.id">{{ elem.text }}}</div>
          </div>
        </div>
        <div class="faq-cols f2">
          <div
            :class="`faq-item ${this.show === elem.id ? 'faq-item-show' : ''}`"
            v-for="elem in FAQ_RC"
            :key="elem.id"
            @click="this.show === elem.id ? (this.show = null) : (this.show = elem.id)"
          >
            <div class="faq-item-title">{{ elem.title }}</div>
            <div class="faq-item-text" v-if="this.show === elem.id">{{ elem.text }}}</div>
          </div>
        </div>
      </div>

      <site-info />
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
const FAQ_LC = [
  {
    id: 0,
    title: 'Как начать играть в игровом клубе Миллионъ?',
    text: 'Для того, чтобы начать играть, вам необходимо зарегистрироваться. Процесс регистрации крайне прост и займёт всего пару минут вашего времени. Вам нужно нажать на кнопку «Регистрация», которая находится в верхней части сайта. Перед вами появится окно, в котором необходимо заполнить поля с информацией. Вам необходимо указать ваш электронный адрес (e-mail), придумать ваше виртуальное имя (логин), под которым вы будете зарегистрированы, а также придумать пароль, который вы будете вводить при входе. После чего нажать на кнопку «Регистрация». Готово! Теперь вы являетесь игроком клуба Миллионъ! Также возможна регистрация с помощью мобильного номера телефона, после регистарции Вам на указанный номер телефон прийдет пароль. Для входа номер телефона является Вашим логином.',
  },
  {
    id: 1,
    title: 'Как сменить пароль и редактировать личные данные?',
    text: 'Сменить пароль, указать свои личные данные, а также их редактировать вы сможете в вашем личном кабинете, нажав в верхней части сайта на Кассу и перейдя во вкладку «Мой профиль».',
  },
  {
    id: 2,
    title: 'Что такое бонус «Возврат»?',
    text: 'Каждый игрок, начиная от уровня «Бронзовый», может в любой момент вернуть себе на счет сумму до 50% от проигранных средств в зависимости от уровня. При этом бонус зачисляется реальными деньгами и его не нужно отыгрывать по вейджеру или с минимальным вейджером в зависимости от Вашего уровня. Возвращенные деньги полностью в вашем распоряжении, вы можете продолжить играть на них или же получить удобным для Вас способом. Сумма возврата зависит от суммы совершенных депозитов и непосредственно от уровня игрока. Чем он выше, тем больше процент. Подробную информацию о распределении процентов вы найдете на странице «Уровни».',
  },
  {
    id: 3,
    title: 'Как получить выигрыш?',
    text: 'Вам необходимо войти в кассу, нажать на закладку «Получить выигрыш». В списке платежных систем выбрать подходящую для вас систему. Указать сумму для вывода, валюту (если доступно), реквизиты, на которые будет отправлен выигрыш, после чего нажать кнопку «Получить». Вы будете проинформированы о сформированной заявке и в течение нескольких минут деньги поступят на ваш счет, после проверки службой безопасности, которая длится в среднем от 10 минут до 3 часов.',
  },
  {
    id: 4,
    title: 'Что такое джекпот и как его выиграть?',
    text: 'Джекпот - это сумма, которая накапливается в автомате в процессе игры. Чем больше людей играет в автомат с джекпотом, тем быстрее его рост. Для того, чтобы стать победителем не нужно предпринимать никаких сложных действий. Достаточно просто играть в ваши любимые игры и как только на барабанах выпадет необходимая комбинация приз ваш! Подробная информация на странице «Джекпоты».',
  },
  {
    id: 5,
    title: 'Я не нашел ответ на свой вопрос, что делать?',
    text: 'Вы всегда можете связаться с нами, отправив письмо на нашу электронную почту: support@mln.casino . Вы можете отправить нам письмо воспользовавшись специальной формой на странице «Контакты», а также задать вопрос прямо оператору тех поддержки в онлайн чате.',
  },
]
const FAQ_RC = [
  {
    id: 6,
    title: 'Возможна ли регистрация через социальные сети?',
    text: 'Да конечно возможна. Для регистрации и входа вы можете использовать ваши аккаунты в популярных соц сетях, например, vk, telegram, facebook, google и другие. Для этого в верхней части сайта вам нужно нажать на кнопку соответствующей соц сети и следовать интрукциям.',
  },
  {
    id: 7,
    title: 'Предлагаете ли вы бонусы игрокам?',
    text: 'Игровой клуб Миллион имеет свою уникальную многоуровневую бонусную систему для игроков. В зависимости от активности вашей игры вы будете получать соответствующие уровни. Этот путь будет длиться на протяжении 12 уровней, начиная от «Новичка» и заканчивая уровнем «Миллионер». За каждый достигнутый уровень положена награда в виде денежного приза, который вы получите реальными деньгами, без необходимости отыгрываться по вейджеру (в зависимости от уровня). Даное ограничение действует не на все уровни. Также вы получите возможность возврата проигранных средств. Подробную информацию о данной бонусной системе вы найдете на странице «Уровни».',
  },
  {
    id: 8,
    title: 'Как пополнить игровой счет?',
    text: 'Вам необходимо войти в свой аккаунт далее перейти в кассу, нажать на закладку «Пополнить». В списке платежных систем выбрать подходящую для вас систему. Указать сумму для пополнения, валюту пополнения (если доступно) после чего нажать кнопку «Пополнить». Вы перейдете на сайт платежной системы, где нужно следовать инструкциям, для оформления платежа. Сразу после оплаты средства будут зачислены и вы будете проинформированы о пополнении баланса.',
  },
  {
    id: 9,
    title: 'Что делать если оплатил, а баланс не пополнился?',
    text: 'Обратитесь в службу поддержки, указав дату и время операции, сумму пополнения, платежную систему, через которую была произведена оплата, а так же уникальный номер платежа, который можно посмотреть в примечании незачисленного платежа из истории операций на сайте вашей платежной системы.',
  },
  {
    id: 10,
    title: 'Какие суточные лимиты на снятие со счета?',
    text: 'На сайте действует ограничение на снятие со счета в сутки, в зависимости от вашего уровня: Новичок - 10 000 рублей в сутки. Бронзовый - 15 000 рублей в сутки. Серебрянный - 20 000 рублей в сутки. Золотой - 30 000 рублей в сутки. Платиновый - 40 000 рублей в сутки. Бриллиантовый - 50 000 рублей в сутки. VIP - 60 000 рублей в сутки. VIP 1-10 - 75 000 рублей в сутки. Супер VIP - 100 000 рублей в сутки. Легендарный - 300 000 рублей в сутки. Премиум - 500 000 рублей в сутки. Хайроллер - 1 000 000 рублей в сутки. Миллионер - без лимита в сутки. Суммы свыше лимита обговариваются индивидуально с администрацией.',
  },
  {
    id: 11,
    title: 'Что делать когда достиг уровня с призами MacBook или iPhone?',
    text: 'Поздравляем, если Вы достигли уровня Супер VIP или Легендарный. Для получения бонуса обратитесь в службу поддержки онлайн для дальнейшей инструкции получения Iphone или Macbook. Для уровня Супер VIP - подарок iPhone последней модели на 128 GB стоимостью 799$ или эквивалент суммы стоимости товара по курсу центрального банка РФ на момент зачисления может быть зачислена Вам на счет без вейджера. Цвет модели можете выбрать самостоятельно. Для уровня Легендарный - подарок Macbook PRO 14” последней модели на 512 GB стоимостью 1599$ или эквивалент суммы стоимости товара по курсу центрального банка РФ на момент зачисления или эквивалент суммы стоимости товара может быть зачислена Вам на счет без вейджера. Цвет модели можете выбрать самостоятельно.',
  },
]

import SliderFaq from '@/components/sliders/SliderFaq'
import PlayLine from '@/components/PlayLine'
import BonusesLine from '@/components/BonusesLine.vue'
import TheNav from '@/components/TheNav'
import SiteInfo from '@/components/SiteInfo'

export default {
  name: 'Faq',
  components: { SliderFaq, PlayLine, BonusesLine, TheNav, SiteInfo },
  setup() {
    return { FAQ_LC, FAQ_RC }
  },
  data() {
    return {
      show: null,
      showTooltip: false,
      showVip: false,
      curVip: '',
    }
  },
}
</script>

<style scoped></style>
